import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auditorias',
  templateUrl: './auditorias.component.html',
  styleUrls: ['./auditorias.component.scss']
})
export class AuditoriasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
